import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { IThemeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { ElementBaseCopyUiModel } from './copy-ui-model/model/base';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { getElementCopiedSdkModelByModel } from './copy-sdk-model/factory';
import { ICopyModelHandler, ICopySdkModelConfig } from './index.interface';
import { PageCopySdkModel } from './copy-sdk-model/model/page';
import { ThemeCopySdkModel } from './copy-sdk-model/model/theme';

const elementBaseModelTypes = [UIModelType.GROUP, UIModelType.CHART, UIModelType.SHAPE,
    UIModelType.TABLE, UIModelType.IMAGE, UIModelType.CONNECTOR];

export class CopyModelHandler implements ICopyModelHandler {
    private model: IBaseModel;
    public constructor(model) {
        this.model = model;
    }

    public getCopiedSdkModel(config: ICopySdkModelConfig = {}): IBaseModel | undefined {
        let copySdkModel;
        switch (this.model.type) {
            case UIModelType.SLIDE:
            case UIModelType.LAYOUT:
            case UIModelType.MASTER:
                copySdkModel = new PageCopySdkModel(this.model as IMasterModel);
                break;
            case UIModelType.THEME:
                copySdkModel = new ThemeCopySdkModel(this.model as IThemeModel);
                break;
            case UIModelType.NOTE:
                copySdkModel = {};
                break;
            default:
                copySdkModel = getElementCopiedSdkModelByModel(this.model);
        }
        return copySdkModel.getCopiedSdkModel?.(config);
    }

    public getCopiedUiModelWithSdkModel(emptyCopiedUIModel: IBaseModel): IBaseModel | null {
        if (elementBaseModelTypes.includes(this.model.type)) {
            return new ElementBaseCopyUiModel(this.model as IElementBaseModel)
                .getCopiedUiModelWithSdkModel(emptyCopiedUIModel as IElementBaseModel);
        }
        return null;
    }
}
